var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.6 112.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.27,1.5c0,8.78-8.62,16.35-21.08,19.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.63,23.44c-19.66-.44-35.36-10.1-35.36-21.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.8,1.5c0,8.3-7.71,15.52-19.08,19.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.33,1.5c0,12.13-16.46,21.96-36.77,21.96S111.8,13.63,111.8,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.23,19.16c-9.04-4-14.9-10.42-14.9-17.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.1,23.46c-4.43,0-8.68-.47-12.62-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.27,89.16c0,8.78-8.62,16.35-21.08,19.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.63,111.1c-19.66-.44-35.36-10.1-35.36-21.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.8,89.16c0,8.3-7.71,15.52-19.08,19.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.56,111.12c-20.31,0-36.77-9.83-36.77-21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.33,89.16c0,8.13-7.39,15.22-18.38,19.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.1,111.12c-20.31,0-36.77-9.83-36.77-21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.25,45.23c-1.56,.12-3.14,.18-4.75,.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.86,22.72c-1.15,.35-3.78,.74-5.39,.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.11,41.85c-1.15,.35-3.17,1.11-7.27,1.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.27,23.46c0,5.32-3.16,10.19-8.43,13.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.95,42.23c-10.6-3.85-17.68-10.82-17.68-18.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.8,23.46c0,12.13-16.46,21.96-36.77,21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.92,44.85c-2.68,.37-5.48,.57-8.35,.57-20.31,0-36.77-9.83-36.77-21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.33,23.46c0,5.93-3.93,11.3-10.32,15.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.21,35.37c-3.72-3.43-5.88-7.52-5.88-11.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.1,45.41c-6.1,0-11.85-.89-16.91-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.51,65.72c-4.32,1.06-9.05,1.65-14.01,1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.27,45.41c0,5.31-3.16,10.19-8.42,13.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.01,66.55c-3.17,.53-6.52,.82-9.98,.82-20.31,0-36.77-9.83-36.77-21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.8,45.41c0,5.32-8.11,13.99-13.48,16.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.32,65.12c-12.16-3.58-20.53-11.06-20.53-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.33,45.41c0,12.13-16.46,21.96-36.77,21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.1,65.73c-13.36-3.29-22.77-11.14-22.77-20.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.27,67.37c0,5.99-4.02,11.43-10.54,15.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.44,89.16c-18.14-1.35-32.17-10.59-32.17-21.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.8,67.37c0,8.68-8.44,16.19-20.68,19.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.33,67.37c0,12.13-16.46,21.96-36.77,21.96s-36.77-9.83-36.77-21.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.64,88.75c-16.23-2.28-28.31-10.99-28.31-21.37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/Wave.456ca6ca3786b24a1462acbada1c3ed3.svg";
export { ForwardRef as ReactComponent };